import './styles/main.scss';
import './assets/images.js';
import U from './js/utils';
import O from './js/core';
import comp from './components/barrel.js';
import svg from './js/svg';

window.U = U;
window.O = O;
window.comp = comp;
window.svg = svg;

// Helper for selectThead: tries thsTab, thsPage, then thsSubTab (View User subtabs, etc.)
window.selectTheadChange = function (onchangeStr) {
  const fn = onchangeStr.replace(/^ths(Page|Tab|SubTab)\./, '').replace('()', '');
  const t =
    window.thsTab && typeof window.thsTab[fn] === 'function'
      ? window.thsTab
      : window.thsPage && typeof window.thsPage[fn] === 'function'
        ? window.thsPage
        : window.thsSubTab && typeof window.thsSubTab[fn] === 'function'
          ? window.thsSubTab
          : null;
  if (t) t[fn]();
};

document.addEventListener('DOMContentLoaded', async (e) => {
  window.pgList = {};
  window.thsPage = {};
  window.thsTab = {};
  window.thsSubTab = {};
  window.communal = {};
  window.userSession = {};
  window.timeout = 0;

  const currentPageTitle = history.state ? JSON.parse(history.state).pageTitle : null;

  const directUuid = O.getDirectApplicationUuid();
  if (directUuid && (await O.isLoggedIn())) {
    await O.bootstrapAuthenticatedApp();
    await O.navigateToDirectApplication(directUuid);
    O.clearDirectApplicationParam();
    await U.getCommunalDropdowns();
  } else if (currentPageTitle && currentPageTitle !== 'Login') {
    O.popstate(history.state);
  } else {
    await O.PREP('Login');
  }

  window.addEventListener('popstate', function (event) {
    O.popstate(event.state);
  });
});
